export default {
  ON_BOARDING_STATUS_REPOSITORY: Symbol.for('ON_BOARDING_STATUS_REPOSITORY'),
  GET_ON_BOARDING_STATUS_QUERY: Symbol.for('GET_ON_BOARDING_STATUS_QUERY'),
  COMPLETE_ON_BOARDING_COMMAND: Symbol.for('COMPLETE_ON_BOARDING_COMMAND'),
};
